import React, { useState } from "react";
import "./mobile-add-card.scss";
import CartIconWhite from "../../../images/home/cart-icon-white.svg";
import { Offcanvas } from "reactstrap";
import CartHeader from "../CartHeader";

const MobileAddCart = (props) => {
  const [isCartOpen, setIsCartOpen] = useState(false);

  let cartItems = JSON.parse(localStorage.getItem("cart"));
  let totalAmount = 0;
  if (cartItems) {
    cartItems.forEach((item) => {
      totalAmount += item?.quantity * item?.catalogData.price;
    });
  }

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };
  const closeCart = () => {
    setIsCartOpen(false);
  };

  return (
    <>
      {props?.itemCount > 0 && !isCartOpen && !props?.hide ? (
        <div
          className="mobile-add-card"
          onClick={() => {
            toggleCart(!isCartOpen);
          }}
        >
          <div className="mobile-add-card-info">
            <div className="mobile-add-card-icon">
              <img src={CartIconWhite} alt="" />
            </div>
            <div className="mobile-add-card-text">
              <div className="mobile-add-card-items">
                {props?.itemCount} item
              </div>
              <div className="mobile-add-card-price">₹ {totalAmount}</div>
            </div>
          </div>
          <div className="mobile-add-card-view-cart">
            View Cart <span className="arrow">›</span>
          </div>
        </div>
      ) : (
        <></>
      )}
      <Offcanvas
        isOpen={isCartOpen}
        toggle={closeCart}
        direction="end"
        backdrop={true}
        className="offcanvas offcanvas-end sidebaroffcanvas"
      >
        <CartHeader isCartOpen={isCartOpen} closeCart={closeCart} />
      </Offcanvas>
    </>
  );
};

export default MobileAddCart;
